import EA from 'helpers/init';

// Add method to <img> element, add your img path to "data-src", leave empty src (src="")
export default EA.Methods.imageLazyLoad = ($this) => {
    const imageEl = $this;

    // Skip if already loaded or no data-src
    if (!imageEl.dataset.src) {
        return;
    }

    let observer;

    function handleIntersect(entries, observer) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const dataSrc = imageEl.dataset.src;
                // Double check that image hasn't been loaded by another method
                if (dataSrc) {
                    const currentSrcAttr = imageEl.getAttribute('src');
                    if (!currentSrcAttr || currentSrcAttr.trim() === '' || currentSrcAttr === dataSrc) {
                        imageEl.src = dataSrc;
                        imageEl.removeAttribute('data-src');
                    }
                }
                observer.unobserve(imageEl);
            }
        });
    }

    function createObserver() {
        // Check if IntersectionObserver is supported
        if (typeof IntersectionObserver === 'undefined') {
            // Fallback: load immediately if IntersectionObserver not supported
            if (imageEl.dataset.src) {
                imageEl.src = imageEl.dataset.src;
                imageEl.removeAttribute('data-src');
            }
            return;
        }

        // Check if image is already in viewport before creating observer
        const rect = imageEl.getBoundingClientRect();
        const isInViewport = rect.top < window.innerHeight + 50 && rect.bottom > -50;

        if (isInViewport) {
            // Image is already in viewport, load it immediately
            const dataSrc = imageEl.dataset.src;
            if (dataSrc) {
                imageEl.src = dataSrc;
                imageEl.removeAttribute('data-src');
            }
            return;
        }

        const options = {
            root: null,
            rootMargin: '50px', // Start loading 50px before entering viewport
            threshold: 0,
        };

        observer = new IntersectionObserver(handleIntersect, options);
        observer.observe(imageEl);
    }

    createObserver();
};

